import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const ttpHistoryPersonUrl = `${SERVER_API}/ttp-registries/ttp-history/persons`;

export const ttpHistoryFileUrl = `${SERVER_API}/ttp-registries/ttp-history/files`;

export const ttpHistoryOrganizationUrl = `${SERVER_API}/ttp-registries/ttp-history/organizations`;

export const TTP_HISTORY = {
  PERSON(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${ttpHistoryPersonUrl}/${id.toString()}`,
    };
  },
  PERSON_IDENTITY_DOCUMENT(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${ttpHistoryPersonUrl}/${id.toString()}/identity-document`,
    };
  },
  PERSON_ECONOMIC_AGREEMENT(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${ttpHistoryPersonUrl}/${id.toString()}/economic-agreement`,
    };
  },
  PERSON_DEER(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${ttpHistoryPersonUrl}/${id.toString()}/deer`,
    };
  },
  FILES(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${ttpHistoryFileUrl}/${id.toString()}`,
    };
  },
  ORGANIZATION(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${ttpHistoryOrganizationUrl}/${id.toString()}`,
    };
  },
  ORGANIZATION_FOUNDERS(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${ttpHistoryOrganizationUrl}/${id.toString()}/founders`,
    };
  },
  ORGANIZATION_WORKERS(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${ttpHistoryOrganizationUrl}/${id.toString()}/workers`,
    };
  },
  ORGANIZATION_GOV_SUPPORT(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${ttpHistoryOrganizationUrl}/${id.toString()}/gov-support`,
    };
  },
  ORGANIZATION_MTS(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${ttpHistoryOrganizationUrl}/${id.toString()}/mts`,
    };
  },
  ORGANIZATION_QUOTAS(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${ttpHistoryOrganizationUrl}/${id.toString()}/quotas`,
    };
  },
  ORGANIZATION_TERRITORY(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${ttpHistoryOrganizationUrl}/${id.toString()}/territory`,
    };
  },
  ORGANIZATION_BUILDING(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${ttpHistoryOrganizationUrl}/${id.toString()}/building`,
    };
  },
};
